<script>
export default {
  name: "ProposalDraftInfoMessage",
  methods: {
    openEditProposalView() {
      this.$emit('on-edit-proposal');
    },
    goToPublishProposal() {
      this.$emit('on-go-to-publish');
    }
  }
}
</script>

<template>
<div class="proposal-draft-info-message">
  <div class="proposal-draft-info-message__icon"></div>
  <span class="proposal-draft-info-message__text">Your proposal is not yet published</span>
  <div class="proposal-draft-info-message__actions">
    <button type="button" class="action-btn mr-20" @click="openEditProposalView">Back to editing</button>
    <button type="button" class="action-btn action-btn--secondary" @click="goToPublishProposal">Publish proposal</button>
  </div>
</div>
</template>

<style lang="scss" scoped>
.proposal-draft-info-message {
  display: flex;
  align-items: center;
  height: 45px;
  margin-bottom: 10px;
  padding: 0 10px;
  border-radius: 8px;
  box-shadow: 0 4px 24px 4px rgba(161, 99, 205, 0.3);
  background: #fff;

  &__icon {
    width: 25px;
    min-width: 25px;
    height: 25px;
    margin-right: 10px;
    background: url("~@/assets/img/profile/orange-info-icon.svg") no-repeat center;
  }
  &__text {
    font-size: 16px;
    font-weight: 600;
    font-family: 'Open Sans', Arial, sans-serif;
    color: #4f4f4f;
  }
  &__actions {
    margin-left: auto;
    .action-btn {
      height: 20px;
      padding: 0 10px;
      color: #7b7b7b;
      border-radius: 10px;
      border: solid 1px #d1d1d1;
      font-size: 12px;
      font-weight: 600;
      font-family: 'Open Sans', Arial, sans-serif;
      cursor: pointer;

      &--secondary {
        background: #a163cd;
        border-color: #a163cd;
        color: #fff;
      }
    }

  }
}
</style>